<template>
    <div class="partner" >
        <Carousel  :list="config.banner.partner"/>
        <Sections>
            <Title class="animation" anniset="animated fadeInDown"  title="合作企业" description="规模大、实力强、品质保障、技术先进、储量丰富"></Title>
            <div class="main animation" anniset="animated fadeInUp">
                <!-- <div class="box" v-for="(item,index) in config.partner" :key="index" @click="open(item.url)">
                    <div class="img">
                        <img class="card-img-top" :src="item.img" alt="Card image" style="width:100%">
                    </div>
                    <div class="card-body card">
                        <h4 class="card-title">{{item.name}}</h4>
                        <p class="card-text">{{item.description}}</p>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-lg-3 col-md-4" v-for="(item,index) in config.partner" v-if="index < 5" :key="index">
                        <div class="items sacleBig text-center" @click="open(item.url)">
                            <img class="img-responsive" :src="item.img" />
                            <h3 class="text-center">{{item.name}}</h3>
                            <!-- <p>by @mdo</p> -->
                            <p>{{item.description}}</p>
                        </div>
                    </div>         
                </div>
            </div>
        </Sections>
    </div>
</template>
<script>
    import Carousel from '@/components/Carousel'
    import Title from '@/components/Title'
    import Sections from '@/components/Sections'
    export default {
        components: {
            Carousel,Title,Sections
        },
        data(){
            return{
                config
            }
        },
        methods:{
            open(url){
                window.open(url);
            }
        },
        mounted(){
            let documentClientHeight = document.documentElement.clientHeight || window.innerHeight;
            let containers = $('body').find('.animation');
            window.addEventListener("scroll",function(e){
            $.each(containers, function (index, item) {
                var top = item.getBoundingClientRect().top;
                if (documentClientHeight >= top) {
                    $(item).addClass($(item).attr('anniset'));
                }
            });
            });
            $.each(containers, function (index, item) {
                let  top = item.getBoundingClientRect().top;
                if (documentClientHeight >= top) {
                $(item).addClass($(item).attr('anniset'));
                }
            });
        }
    }
</script>
<style lang="less" scoped>
// .main{
//     display: flex;
//     flex-wrap: wrap;
//     .box{
//         flex: 0 0 calc(~'100% / 7');
//         margin-bottom: 20px;
//         box-sizing: border-box;
//         margin-right:2.382%;
//         .card-text{
//             text-overflow: ellipsis; /*超出部分裁剪，必须*/
//             display: -webkit-box; /*必须*/
//             -webkit-box-orient: vertical; /*属性规定框的子元素应该被水平或垂直排列。*/                    
//             overflow: hidden; /*超出部分隐藏*/
//             -webkit-line-clamp: 3; /*在第几行的时候超出部分隐藏*/
//             height: 60px;
//         }
//         img{
//             transition: 0.5s;
//             width: 100%;
            
//         }
//         .img{
//             width:100%;height:0;position: relative;padding-bottom: 100%;
//             img{
//                 width:100%;height:100%;position: absolute;
//                 &:hover{
//                     transform: scale(1.3)
//                 }
//             }
//         }
//     }
// }
// @media only screen and (max-width: 786px){
//     .main{
//         .box{
//             flex: 0 0 50%;
//             text-align: center;
//             margin-right: 0;
//             box-sizing: border-box;
//             padding: 0 2%;
//         }
//     }
// }
// @media only screen and (max-width: 500px){
//     .main{
//         .box{
//             flex: 0 0 100%;
//             text-align: center;
//             margin-right: 0;
//         }
//     }
// }
.main{
    max-width: 1200px;
    margin:  0 auto;
}
.items{
    position: relative;
    margin: 80px 0;
    text-align: left;
    background-color: #ffffff;
    border-radius: 10px;
    min-height: 250px;
    box-shadow: 0 0 5px #999;
    box-sizing: border-box;
    padding: 60px 10px 10px;
    p{
        height: 140px;
        overflow: hidden;
    }
    img{
        box-shadow: 0 0 5px #999;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 120px;
        height: 120px;
        border: 10px solid #ffffff;
        border-radius: 50%;
    }
}
</style>
